module.exports = __webpack_public_path__ + "img/triangle-01-fore-01.cc485e14.svg";